module.exports = __webpack_public_path__ + "img/dhHistory0224.16401162.png";